import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { LinkBankAccountRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { LinkBankAccountResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const linkBankAccount = (request: LinkBankAccountRequest, options?: CashRequestOptions) =>
  post<LinkBankAccountRequest, LinkBankAccountResponse>('/2.0/cash/link-bank-account', request, {
    ...options,
    rejectOnError: true,
  })
